import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
const bonuses = [{
  id: 1,
  title: 'BONO 1 – Juegos de Patio y Gimnasio',
  desc: 'Un banco completo de juegos listos para aplicar, adaptables a patios, gimnasios y distintos grupos.',
  img: 'https://cdn.magicpatterns.com/uploads/daZk6Cr1WwNzg8bCz3Cf8H/bono_1.png',
  spineColor: '#1565C0'
}, {
  id: 2,
  title: 'BONO 2 – Rúbricas y Evaluaciones LISTAS™',
  desc: 'Evaluaciones claras, rúbricas simples y criterios objetivos para evaluar sin dudas ni estrés.',
  img: 'https://cdn.magicpatterns.com/uploads/nTd3oYn3NTFUuqvnhUmNru/bono_2.png',
  spineColor: '#C62828'
}, {
  id: 3,
  title: 'BONO 3 – Actividades en Espacios Reducidos',
  desc: 'Clases efectivas incluso cuando el espacio no acompaña. Ideal para días difíciles o escuelas con limitaciones.',
  img: 'https://cdn.magicpatterns.com/uploads/3NpYhKtd9rcmE2siPQ4GDy/bono_3.png',
  spineColor: '#2E7D32'
}, {
  id: 4,
  title: 'BONO 4 – Kit de Juegos Híper Práctico',
  desc: 'Ideas rápidas, claras y funcionales para resolver clases en minutos sin improvisar.',
  img: 'https://cdn.magicpatterns.com/uploads/eAavdGDwKT6TkE74KtW7RF/bono_4.png',
  spineColor: '#E65100'
}];
function Book3D({
  img,
  spineColor,
  alt
}: {
  img: string;
  spineColor: string;
  alt: string;
}) {
  return <div className="relative w-[160px] h-[220px] md:w-[180px] md:h-[250px] flex-shrink-0" style={{
    perspective: '600px'
  }} data-id="element-16">
      {/* Book container with 3D transform */}
      <div className="relative w-full h-full transition-transform duration-500 group-hover:rotate-y-[-8deg]" style={{
      transformStyle: 'preserve-3d',
      transform: 'rotateY(-15deg)'
    }} data-id="element-17">
        {/* Front cover */}
        <div className="absolute inset-0 rounded-r-md overflow-hidden shadow-2xl" style={{
        transformStyle: 'preserve-3d',
        backfaceVisibility: 'hidden'
      }} data-id="element-18">
          <img src={img} alt={alt} className="w-full h-full object-cover" data-id="element-19" />
        </div>

        {/* Spine */}
        <div className="absolute top-0 left-0 h-full rounded-l-sm" style={{
        width: '18px',
        background: `linear-gradient(to right, ${spineColor}, ${spineColor}dd)`,
        transform: 'translateX(-17px) rotateY(90deg)',
        transformOrigin: 'right center',
        boxShadow: 'inset -2px 0 4px rgba(0,0,0,0.3)'
      }} data-id="element-20" />

        {/* Page edges (right side) */}
        <div className="absolute top-[3px] right-[-2px] bottom-[3px]" style={{
        width: '6px',
        background: 'linear-gradient(to right, #f5f0e8, #e8e0d4)',
        borderRadius: '0 1px 1px 0',
        boxShadow: 'inset -1px 0 2px rgba(0,0,0,0.1)'
      }} data-id="element-21" />

        {/* Bottom page edges */}
        <div className="absolute bottom-[-3px] left-[4px] right-[4px]" style={{
        height: '6px',
        background: 'linear-gradient(to bottom, #f5f0e8, #e8e0d4)',
        borderRadius: '0 0 1px 1px',
        boxShadow: '0 1px 2px rgba(0,0,0,0.15)'
      }} data-id="element-22" />
      </div>

      {/* Shadow beneath book */}
      <div className="absolute -bottom-3 left-1/2 -translate-x-1/2 w-[85%] h-[12px] rounded-full opacity-50" style={{
      background: 'radial-gradient(ellipse, rgba(0,0,0,0.6) 0%, transparent 70%)'
    }} data-id="element-23" />
    </div>;
}
export function BonusSection() {
  const scrollToPurchase = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-20 bg-[#0F172A] text-white" data-id="element-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-25">
        <div className="text-center mb-16" data-id="element-26">
          <div className="inline-flex items-center gap-2 bg-[#DC2626] text-white px-6 py-2 rounded-full font-bold text-lg mb-6 animate-bounce" data-id="element-27">
            <Gift className="w-5 h-5" data-id="element-28" />
            <span data-id="element-29">¡GRATIS solo por hoy!</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-black mb-4" data-id="element-30">
            🎁 Bonos incluidos{' '}
            <span className="text-[#F59E0B]" data-id="element-31">(sin costo extra)</span>
          </h2>
          <p className="text-xl text-gray-300" data-id="element-32">
            Llevate todo este material complementario totalmente gratis con tu
            compra.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-10" data-id="element-33">
          {bonuses.map((bonus, index) => <motion.div key={bonus.id} initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.15,
          duration: 0.5
        }} className="flex flex-col sm:flex-row items-center gap-6 bg-gradient-to-br from-gray-800 to-gray-900 rounded-2xl p-6 md:p-8 border border-gray-700 hover:border-[#F59E0B] transition-all duration-300 cursor-pointer group relative" onClick={scrollToPurchase} data-id="element-34">
              {/* GRATIS badge */}
              <div className="absolute top-3 right-3 bg-[#F59E0B] text-[#0F172A] font-black text-xs px-3 py-1 rounded-full shadow-lg uppercase tracking-wider z-10" data-id="element-35">
                🎁 GRATIS
              </div>

              {/* 3D Book */}
              <div className="flex items-center justify-center py-4" data-id="element-36">
                <Book3D img={bonus.img} spineColor={bonus.spineColor} alt={bonus.title} data-id="element-37" />
              </div>

              {/* Text content */}
              <div className="flex-1 text-center sm:text-left" data-id="element-38">
                <h3 className="text-xl font-bold text-[#F59E0B] mb-3 leading-tight" data-id="element-39">
                  {bonus.title}
                </h3>
                <p className="text-gray-300 leading-relaxed text-base" data-id="element-40">
                  {bonus.desc}
                </p>
                <span className="inline-block mt-4 text-sm font-semibold text-[#F59E0B] opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-41">
                  Ver más →
                </span>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}